import React from 'react';
import { Image } from 'src/components/common/Image';
import styles from './Carousel.module.scss';
const carouselData = [{
  title: 'Augmented Reality Guidance',
  img: 'cancelling-1.webp'
}, {
  title: `Advanced
Programs`,
  img: 'cancelling-2.webp'
}, {
  title: `New
Challenges`,
  img: 'cancelling-3.webp'
}];
const ItemInCarousel = React.memo(({
  title,
  img
}: {
  title: string;
  img: string;
}) => <div className={styles.item}>
      <span className={styles.badge}>Coming soon</span>
      <h2 className={styles.title}>{title}</h2>
      <Image src={img} width={232} height={326} alt="cancelling" />
    </div>);
ItemInCarousel.displayName = 'ItemInCarousel';
export const Carousel = () => <div className={styles.container} data-sentry-component="Carousel" data-sentry-source-file="index.tsx">
    <div className={styles.carousel}>
      {carouselData.map(({
      title,
      img
    }) => <ItemInCarousel title={title} img={img} key={title} />)}
    </div>
  </div>;